import { useInfiniteQuery } from '@tanstack/react-query';
import { useApiClient } from '../contexts/ApiContext';
import { queryKeys } from '../lib/queryClient';

export function useReferralContestLeaderboard(enabled = true) {
  const apiClient = useApiClient();

  return useInfiniteQuery({
    queryKey: queryKeys.referralContest,
    queryFn: ({ pageParam }) => apiClient.api.referralContestControllerGetLeaderboard({ offset: pageParam }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, _pages, lastOffset) =>
      lastPage.hasMore ? lastOffset + lastPage.entries.length : undefined,
    enabled,
    staleTime: 60 * 1000,
    // WHY: polling an infinite query refetches every loaded page; a rank moving between pages mid-refetch duplicates or drops
    // a row
    refetchInterval: (query) => ((query.state.data?.pages.length ?? 1) > 1 ? false : 60 * 1000),
  });
}
